import Layout from '../../components/admin/Layout';
import FormProducto from '../../components/admin/formProducto';

const AltaProductos = () => {


	return (
		<Layout
			pagina={"Producto"}
		>
			<div className='w-full p-5 min-h-full'>
				<FormProducto/>
			</div>
		</Layout>
	)
}

export default AltaProductos